import { render, staticRenderFns } from "./index.vue?vue&type=template&id=8684406c&scoped=true"
var script = {}
import style0 from "./index.vue?vue&type=style&index=0&id=8684406c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8684406c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\2026\\Halov2-Fishery-Upgrade\\halov-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8684406c')) {
      api.createRecord('8684406c', component.options)
    } else {
      api.reload('8684406c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=8684406c&scoped=true", function () {
      api.rerender('8684406c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/error/411/index.vue"
export default component.exports